<template>
  <div class="col-span-6" v-bind:class="'sm:col-span-' + columns">
    <ValidationProvider :rules="rules" v-slot="v" :disabled="valdisabled">
      <label :for="label" class="block text-sm font-medium leading-5 text-gray-700">
        {{ label }}
        <span class="text-xs text-red-500" v-if="rules && rules.includes('required') && !valdisabled">*</span>
        <span
          v-show="tooltip"
          :data-tooltip="tooltip"
          class="ml-1 inline-flex items-center px-1.5 rounded-full text-xs font-normal leading-4 bg-gray-100 text-gray-800"
        >?</span>
      </label>
      <input
        :type="type || 'text'"
        :readonly="readonly"
        :value="value"
        :id="label"
        :name="label"
        :min="mindate"
        :max="maxdate"
        @input="onChange"
        :placeholder="placeholder"
        :class="{'bg-pink-50': v.errors[0], 'bg-blue-100' : readonly}"
        class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      />
      <div class="text-xs text-red-500 h-2"><span v-if="v.errors[0]">{{ v.errors[0] }}</span></div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "text-input",
  props: {
    label: String,
    placeholder: String,
    tooltip: String,
    value: String,
    columns: String,
    type: String,
    rules: String,
    valdisabled: Boolean,
    readonly: Boolean,
    mindate: String,
    maxdate: String
  },

  data: function() {
    return {};
  },

  computed: {},

  methods: {
    onChange: function(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>

<style scoped>
[data-tooltip]:hover {
  position: relative;
}
[data-tooltip]:hover::before {
  all: initial;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
  border-radius: 5px;
  padding: 10px;
  background-color: #777;
  content: attr(data-tooltip);
  color: #f9f9f9;
  position: absolute;
  bottom: 100%;
  width: 300px;
  left: 50%;
  transform: translate(-50%, 0);
  margin-bottom: 15px;
  text-align: center;
  font-size: 14px;
}
</style>